// 团队介绍
var mySwiper2 = new Swiper(".index-activity-box #team-container", {
  loop: true,
  spaceBetween: 40,
  slidesPerView: 4,
  prevButton: ".index-activity-box .swiper-button-prev",
  nextButton: ".index-activity-box .swiper-button-next",
  breakpoints: {
    // 当宽度小于等于1199
    1199: {
      spaceBetween: 20,
      slidesPerView: 4,
    },
    991: {
      spaceBetween: 30,
      slidesPerView: 3,
    },
    767: {
      spaceBetween: 20,
      slidesPerView: 3,
    },
    480: {
      slidesPerView: 2.4,
      spaceBetween: 10
    },
  },

});

// 年份
var mySwiper6 = new Swiper(".history-tab", {
  slidesPerView: "auto",
  watchSlidesProgress: true,
  watchSlidesVisibility: true,
  resistanceRatio: 0,
  onTap: function () {
    $('.swiper-button-prev').removeClass('swiper-button-disabled');
    $('.swiper-button-next').removeClass('swiper-button-disabled');
    mySwiper7.slideTo(mySwiper6.clickedIndex);

  },

});
var mySwiper7 = new Swiper('.idhistory-info', {
  slidesPerView: 1,
  resistanceRatio: 0,
  onSlideChangeStart: function () {
    updateNavPosition()
  },
  onSlideChangeEnd: function (swiper) {
    $('.swiper-button-prev').removeClass('swiper-button-disabled');
    $('.swiper-button-next').removeClass('swiper-button-disabled');
    $('.swiper-button-next').unbind('click');
    $('.swiper-button-prev').unbind('click');

    let realindex = parseInt(swiper.activeIndex) + 1;
    let actindex = window["historySwiper" + realindex].activeIndex;
    let isEnd = window["historySwiper" + realindex].isEnd;
    let isBeginning = window["historySwiper" + realindex].isBeginning;
    if (isEnd) {
      let name = '.history-item' + realindex + '  .swiper-button-next';
      $(name).on('click', function () {
        mySwiper7.slideNext();
      });
    }
    if (isBeginning) {
      let name = '.history-item' + realindex + '  .swiper-button-prev';
      $(name).on('click', function () {
        mySwiper7.slidePrev();
      });
    }
  },
});
function updateNavPosition() {
  $('.history-tab .active-nav').removeClass('active-nav')
  var activeNav = $('.history-tab .swiper-slide').eq(mySwiper7.activeIndex).addClass('active-nav');
  if (!activeNav.hasClass('swiper-slide-visible')) {
    console.log(1);
    if (activeNav.index() > mySwiper6.activeIndex) {
      var thumbsPerNav = Math.floor(mySwiper6.width / activeNav.width()) - 1
      mySwiper6.slideTo(activeNav.index() - thumbsPerNav)
    } else {
      mySwiper6.slideTo(activeNav.index())
    }
  }
}

// 发展历程

var historySwiper1 = new Swiper(".history-item1 .history-container", {
  spaceBetween: 15,
  slidesPerView: 3,
  initialSlide: 0,
  prevButton: ".history-item1 .swiper-button-prev",
  nextButton: ".history-item1 .swiper-button-next",
  onInit: function (swiper) {
    //Swiper初始化了
    if ('1' == 1) {
      setTimeout(function () {
        if (swiper.isEnd) {
          $('.history-item1  .swiper-button-next').removeClass('swiper-button-disabled').on('click', function () {
            mySwiper7.slideNext();
          });
        }
      }, 5000);
    }
  },
  onSlideChangeEnd: function (swiper) {
    if (swiper.activeIndex == (swiper.slides.length - 3)) {
      $('.history-item1  .swiper-button-next').removeClass('swiper-button-disabled').on('click', function () {
        mySwiper7.slideNext();
      })
    } else {
      $('.swiper-button-next').unbind('click');
    }
    if (swiper.activeIndex == 0) {
      $('.history-item1  .swiper-button-prev').removeClass('swiper-button-disabled').on('click', function () {
        mySwiper7.slidePrev();
      })
    } else {
      $('.swiper-button-prev').unbind('click');
    }
  },
  breakpoints: {
    // 当宽度小于等于767
    767: {
      spaceBetween: 10,
      slidesPerView: 2.2,

    },
    480: {
      slidesPerView: 1.4,
      spaceBetween: 10,

    },
  },

});

var historySwiper2 = new Swiper(".history-item2 .history-container", {
  spaceBetween: 15,
  slidesPerView: 3,
  initialSlide: 0,
  prevButton: ".history-item2 .swiper-button-prev",
  nextButton: ".history-item2 .swiper-button-next",
  onInit: function (swiper) {
    //Swiper初始化了
    if ('2' == 1) {
      setTimeout(function () {
        if (swiper.isEnd) {
          $('.history-item2  .swiper-button-next').removeClass('swiper-button-disabled').on('click', function () {
            mySwiper7.slideNext();
          });
        }
      }, 5000);
    }
  },
  onSlideChangeEnd: function (swiper) {
    if (swiper.activeIndex == (swiper.slides.length - 3)) {
      $('.history-item2  .swiper-button-next').removeClass('swiper-button-disabled').on('click', function () {
        mySwiper7.slideNext();
      })
    } else {
      $('.swiper-button-next').unbind('click');
    }
    if (swiper.activeIndex == 0) {
      $('.history-item2  .swiper-button-prev').removeClass('swiper-button-disabled').on('click', function () {
        mySwiper7.slidePrev();
      })
    } else {
      $('.swiper-button-prev').unbind('click');
    }
  },
  breakpoints: {
    // 当宽度小于等于767
    767: {
      spaceBetween: 10,
      slidesPerView: 2.2,

    },
    480: {
      slidesPerView: 1.4,
      spaceBetween: 10,

    },
  },

});

var historySwiper3 = new Swiper(".history-item3 .history-container", {
  spaceBetween: 15,
  slidesPerView: 3,
  initialSlide: 0,
  prevButton: ".history-item3 .swiper-button-prev",
  nextButton: ".history-item3 .swiper-button-next",
  onInit: function (swiper) {
    //Swiper初始化了
    if ('3' == 1) {
      setTimeout(function () {
        if (swiper.isEnd) {
          $('.history-item3  .swiper-button-next').removeClass('swiper-button-disabled').on('click', function () {
            mySwiper7.slideNext();
          });
        }
      }, 5000);
    }
  },
  onSlideChangeEnd: function (swiper) {
    if (swiper.activeIndex == (swiper.slides.length - 3)) {
      $('.history-item3  .swiper-button-next').removeClass('swiper-button-disabled').on('click', function () {
        mySwiper7.slideNext();
      })
    } else {
      $('.swiper-button-next').unbind('click');
    }
    if (swiper.activeIndex == 0) {
      $('.history-item3  .swiper-button-prev').removeClass('swiper-button-disabled').on('click', function () {
        mySwiper7.slidePrev();
      })
    } else {
      $('.swiper-button-prev').unbind('click');
    }
  },
  breakpoints: {
    // 当宽度小于等于767
    767: {
      spaceBetween: 10,
      slidesPerView: 2.2,

    },
    480: {
      slidesPerView: 1.4,
      spaceBetween: 10,

    },
  },

});

var historySwiper4 = new Swiper(".history-item4 .history-container", {
  spaceBetween: 15,
  slidesPerView: 3,
  initialSlide: 0,
  prevButton: ".history-item4 .swiper-button-prev",
  nextButton: ".history-item4 .swiper-button-next",
  onInit: function (swiper) {
    //Swiper初始化了
    if ('4' == 1) {
      setTimeout(function () {
        if (swiper.isEnd) {
          $('.history-item4  .swiper-button-next').removeClass('swiper-button-disabled').on('click', function () {
            mySwiper7.slideNext();
          });
        }
      }, 5000);
    }
  },
  onSlideChangeEnd: function (swiper) {
    if (swiper.activeIndex == (swiper.slides.length - 3)) {
      $('.history-item4  .swiper-button-next').removeClass('swiper-button-disabled').on('click', function () {
        mySwiper7.slideNext();
      })
    } else {
      $('.swiper-button-next').unbind('click');
    }
    if (swiper.activeIndex == 0) {
      $('.history-item4  .swiper-button-prev').removeClass('swiper-button-disabled').on('click', function () {
        mySwiper7.slidePrev();
      })
    } else {
      $('.swiper-button-prev').unbind('click');
    }
  },
  breakpoints: {
    // 当宽度小于等于767
    767: {
      spaceBetween: 10,
      slidesPerView: 2.2,

    },
    480: {
      slidesPerView: 1.4,
      spaceBetween: 10,

    },
  },

});

var historySwiper5 = new Swiper(".history-item5 .history-container", {
  spaceBetween: 15,
  slidesPerView: 3,
  initialSlide: 0,
  prevButton: ".history-item5 .swiper-button-prev",
  nextButton: ".history-item5 .swiper-button-next",
  onInit: function (swiper) {
    //Swiper初始化了
    if ('5' == 1) {
      setTimeout(function () {
        if (swiper.isEnd) {
          $('.history-item5  .swiper-button-next').removeClass('swiper-button-disabled').on('click', function () {
            mySwiper7.slideNext();
          });
        }
      }, 5000);
    }
  },
  onSlideChangeEnd: function (swiper) {
    if (swiper.activeIndex == (swiper.slides.length - 3)) {
      $('.history-item5  .swiper-button-next').removeClass('swiper-button-disabled').on('click', function () {
        mySwiper7.slideNext();
      })
    } else {
      $('.swiper-button-next').unbind('click');
    }
    if (swiper.activeIndex == 0) {
      $('.history-item5  .swiper-button-prev').removeClass('swiper-button-disabled').on('click', function () {
        mySwiper7.slidePrev();
      })
    } else {
      $('.swiper-button-prev').unbind('click');
    }
  },
  breakpoints: {
    // 当宽度小于等于767
    767: {
      spaceBetween: 10,
      slidesPerView: 2.2,

    },
    480: {
      slidesPerView: 1.4,
      spaceBetween: 10,

    },
  },

});

var historySwiper6 = new Swiper(".history-item6 .history-container", {
  spaceBetween: 15,
  slidesPerView: 3,
  initialSlide: 0,
  prevButton: ".history-item6 .swiper-button-prev",
  nextButton: ".history-item6 .swiper-button-next",
  onInit: function (swiper) {
    //Swiper初始化了
    if ('6' == 1) {
      setTimeout(function () {
        if (swiper.isEnd) {
          $('.history-item6  .swiper-button-next').removeClass('swiper-button-disabled').on('click', function () {
            mySwiper7.slideNext();
          });
        }
      }, 5000);
    }
  },
  onSlideChangeEnd: function (swiper) {
    if (swiper.activeIndex == (swiper.slides.length - 3)) {
      $('.history-item6  .swiper-button-next').removeClass('swiper-button-disabled').on('click', function () {
        mySwiper7.slideNext();
      })
    } else {
      $('.swiper-button-next').unbind('click');
    }
    if (swiper.activeIndex == 0) {
      $('.history-item6  .swiper-button-prev').removeClass('swiper-button-disabled').on('click', function () {
        mySwiper7.slidePrev();
      })
    } else {
      $('.swiper-button-prev').unbind('click');
    }
  },
  breakpoints: {
    // 当宽度小于等于767
    767: {
      spaceBetween: 10,
      slidesPerView: 2.2,

    },
    480: {
      slidesPerView: 1.4,
      spaceBetween: 10,

    },
  },

});

var historySwiper7 = new Swiper(".history-item7 .history-container", {
  spaceBetween: 15,
  slidesPerView: 3,
  initialSlide: 0,
  prevButton: ".history-item7 .swiper-button-prev",
  nextButton: ".history-item7 .swiper-button-next",
  onInit: function (swiper) {
    //Swiper初始化了
    if ('7' == 1) {
      setTimeout(function () {
        if (swiper.isEnd) {
          $('.history-item7  .swiper-button-next').removeClass('swiper-button-disabled').on('click', function () {
            mySwiper7.slideNext();
          });
        }
      }, 5000);
    }
  },
  onSlideChangeEnd: function (swiper) {
    if (swiper.activeIndex == (swiper.slides.length - 3)) {
      $('.history-item7  .swiper-button-next').removeClass('swiper-button-disabled').on('click', function () {
        mySwiper7.slideNext();
      })
    } else {
      $('.swiper-button-next').unbind('click');
    }
    if (swiper.activeIndex == 0) {
      $('.history-item7  .swiper-button-prev').removeClass('swiper-button-disabled').on('click', function () {
        mySwiper7.slidePrev();
      })
    } else {
      $('.swiper-button-prev').unbind('click');
    }
  },
  breakpoints: {
    // 当宽度小于等于767
    767: {
      spaceBetween: 10,
      slidesPerView: 2.2,

    },
    480: {
      slidesPerView: 1.4,
      spaceBetween: 10,

    },
  },

});

var historySwiper8 = new Swiper(".history-item8 .history-container", {
  spaceBetween: 15,
  slidesPerView: 3,
  initialSlide: 0,
  prevButton: ".history-item8 .swiper-button-prev",
  nextButton: ".history-item8 .swiper-button-next",
  onInit: function (swiper) {
    //Swiper初始化了
    if ('8' == 1) {
      setTimeout(function () {
        if (swiper.isEnd) {
          $('.history-item8  .swiper-button-next').removeClass('swiper-button-disabled').on('click', function () {
            mySwiper7.slideNext();
          });
        }
      }, 5000);
    }
  },
  onSlideChangeEnd: function (swiper) {
    if (swiper.activeIndex == (swiper.slides.length - 3)) {
      $('.history-item8  .swiper-button-next').removeClass('swiper-button-disabled').on('click', function () {
        mySwiper7.slideNext();
      })
    } else {
      $('.swiper-button-next').unbind('click');
    }
    if (swiper.activeIndex == 0) {
      $('.history-item8  .swiper-button-prev').removeClass('swiper-button-disabled').on('click', function () {
        mySwiper7.slidePrev();
      })
    } else {
      $('.swiper-button-prev').unbind('click');
    }
  },
  breakpoints: {
    // 当宽度小于等于767
    767: {
      spaceBetween: 10,
      slidesPerView: 2.2,

    },
    480: {
      slidesPerView: 1.4,
      spaceBetween: 10,

    },
  },

});

var historySwiper9 = new Swiper(".history-item9 .history-container", {
  spaceBetween: 15,
  slidesPerView: 3,
  initialSlide: 0,
  prevButton: ".history-item9 .swiper-button-prev",
  nextButton: ".history-item9 .swiper-button-next",
  onInit: function (swiper) {
    //Swiper初始化了
    if ('9' == 1) {
      setTimeout(function () {
        if (swiper.isEnd) {
          $('.history-item9  .swiper-button-next').removeClass('swiper-button-disabled').on('click', function () {
            mySwiper7.slideNext();
          });
        }
      }, 5000);
    }
  },
  onSlideChangeEnd: function (swiper) {
    if (swiper.activeIndex == (swiper.slides.length - 3)) {
      $('.history-item9  .swiper-button-next').removeClass('swiper-button-disabled').on('click', function () {
        mySwiper7.slideNext();
      })
    } else {
      $('.swiper-button-next').unbind('click');
    }
    if (swiper.activeIndex == 0) {
      $('.history-item9  .swiper-button-prev').removeClass('swiper-button-disabled').on('click', function () {
        mySwiper7.slidePrev();
      })
    } else {
      $('.swiper-button-prev').unbind('click');
    }
  },
  breakpoints: {
    // 当宽度小于等于767
    767: {
      spaceBetween: 10,
      slidesPerView: 2.2,

    },
    480: {
      slidesPerView: 1.4,
      spaceBetween: 10,

    },
  },

});

var historySwiper10 = new Swiper(".history-item10 .history-container", {
  spaceBetween: 15,
  slidesPerView: 3,
  initialSlide: 0,
  prevButton: ".history-item10 .swiper-button-prev",
  nextButton: ".history-item10 .swiper-button-next",
  onInit: function (swiper) {
    //Swiper初始化了
    if ('10' == 1) {
      setTimeout(function () {
        if (swiper.isEnd) {
          $('.history-item10  .swiper-button-next').removeClass('swiper-button-disabled').on('click', function () {
            mySwiper7.slideNext();
          });
        }
      }, 5000);
    }
  },
  onSlideChangeEnd: function (swiper) {
    if (swiper.activeIndex == (swiper.slides.length - 3)) {
      $('.history-item10  .swiper-button-next').removeClass('swiper-button-disabled').on('click', function () {
        mySwiper7.slideNext();
      })
    } else {
      $('.swiper-button-next').unbind('click');
    }
    if (swiper.activeIndex == 0) {
      $('.history-item10  .swiper-button-prev').removeClass('swiper-button-disabled').on('click', function () {
        mySwiper7.slidePrev();
      })
    } else {
      $('.swiper-button-prev').unbind('click');
    }
  },
  breakpoints: {
    // 当宽度小于等于767
    767: {
      spaceBetween: 10,
      slidesPerView: 2.2,

    },
    480: {
      slidesPerView: 1.4,
      spaceBetween: 10,

    },
  },

});

var historySwiper11 = new Swiper(".history-item11 .history-container", {
  spaceBetween: 15,
  slidesPerView: 3,
  initialSlide: 0,
  prevButton: ".history-item11 .swiper-button-prev",
  nextButton: ".history-item11 .swiper-button-next",
  onInit: function (swiper) {
    //Swiper初始化了
    if ('11' == 1) {
      setTimeout(function () {
        if (swiper.isEnd) {
          $('.history-item11  .swiper-button-next').removeClass('swiper-button-disabled').on('click', function () {
            mySwiper7.slideNext();
          });
        }
      }, 5000);
    }
  },
  onSlideChangeEnd: function (swiper) {
    if (swiper.activeIndex == (swiper.slides.length - 3)) {
      $('.history-item11  .swiper-button-next').removeClass('swiper-button-disabled').on('click', function () {
        mySwiper7.slideNext();
      })
    } else {
      $('.swiper-button-next').unbind('click');
    }
    if (swiper.activeIndex == 0) {
      $('.history-item11  .swiper-button-prev').removeClass('swiper-button-disabled').on('click', function () {
        mySwiper7.slidePrev();
      })
    } else {
      $('.swiper-button-prev').unbind('click');
    }
  },
  breakpoints: {
    // 当宽度小于等于767
    767: {
      spaceBetween: 10,
      slidesPerView: 2.2,

    },
    480: {
      slidesPerView: 1.4,
      spaceBetween: 10,

    },
  },

});